import App from '@/pages/app/index.vue';
import ProjectSelect from '@/pages/app/project_select/index.vue';
import Project from '@/pages/app/project/index.vue';
import Dashboard from '@/pages/app/project/dashboard/index.vue';
import DashboardHome from '@/pages/app/project/dashboard/home/index.vue';
import DashboardOrders from '@/pages/app/project/dashboard/orders/index.vue';
import DashboardOrder from '@/pages/app/project/dashboard/order/index.vue';
import DashboardLoans from '@/pages/app/project/dashboard/loans/index.vue';
import DashboardLoan from '@/pages/app/project/dashboard/loan/index.vue';
import DashboardStudents from '@/pages/app/project/dashboard/students/index.vue';
import DashboardStudent from '@/pages/app/project/dashboard/student/index.vue';
import DashboardPaymentPlans from '@/pages/app/project/dashboard/payment_plans/index.vue';
import DashboardPaymentPlan from '@/pages/app/project/dashboard/payment_plan/index.vue';
import DashboardSettlements from '@/pages/app/project/dashboard/settlements/index.vue';
import DashboardApplications from '@/pages/app/project/dashboard/applications/index.vue';
import DashboardSettings from '@/pages/app/project/dashboard/settings/index.vue';
import DashboardProfile from '@/pages/app/project/dashboard/settings/profile/index.vue';
import DashboardIntegrations from '@/pages/app/project/dashboard/settings/integrations/index.vue';
import ZapierDashboard from '@/pages/app/project/dashboard/settings/integrations/zapier/index.vue';
import StripeForm from '@/pages/app/project/dashboard/settings/integrations/stripe/index.vue';
import NmiForm from '@/pages/app/project/dashboard/settings/integrations/nmi/index.vue';
import AvalaraForm from '@/pages/app/project/dashboard/settings/integrations/sales_tax/avalara/index.vue';
import DashboardSettingsLogo from '@/pages/app/project/dashboard/settings/logo/index.vue';
import DashboardsNotificationsSubscribers from '@/pages/app/project/dashboard/settings/notifications_subscribers/index.vue';
import Onboarding from '@/pages/app/project//onboarding/index.vue';
import OnboardingProgress from '@/pages/app/project//onboarding/progress/index.vue';
import OnboardingSubmitted from '@/pages/app/project//onboarding/submitted/index.vue';
import OnboardingApproved from '@/pages/app/project//onboarding/approved/index.vue';
import OnboardingDeclined from '@/pages/app/project//onboarding/declined/index.vue';
import BusinessDetails from '@/pages/app/project/business_details/index.vue';
import BusinessDetailsReview from '@/pages/app/project/business_details/review/index.vue';
import BusinessName from '@/pages/app/project/business_details/business_name/index.vue';
import BusinessAddress from '@/pages/app/project/business_details/business_address/index.vue';
import ProductSelection from '@/pages/app/project/business_details/product_selection/index.vue';
import UploadLogo from '@/pages/app/project/upload_logo/index.vue';
import UserManagement from '@/pages/app/project/dashboard/settings/team/index.vue';
import BusinessOwner from '@/pages/app/project/business_owner/index.vue';
import BusinessOwnerForm from '@/pages/app/project/business_owner/form/index.vue';
import BusinessOwnerReview from '@/pages/app/project/business_owner/review/index.vue';
import PaymentDetails from '@/pages/app/project/payment_details/index.vue';
import PaymentDetailsForm from '@/pages/app/project/payment_details/form/index.vue';
import PaymentDetailsReview from '@/pages/app/project/payment_details/review/index.vue';
import Pricing from '@/pages/app/project/pricing/index.vue';
import PricingInfo from '@/pages/app/project/pricing/info.vue';
import PricingTerms from '@/pages/app/project/pricing/terms.vue';
import WelcomeVideo from '@/pages/app/project/onboarding/welcome/index.vue';
import QuickStartGuide from '@/pages/app/project/quick_start_guide/index.vue';
import Checkouts from '@/pages/app/project/dashboard/checkouts/index.vue';
import Products from '@/pages/app/project/dashboard/products/index.vue';
import PaymentSettings from '@/pages/app/project/dashboard/payment_settings/index.vue';
import Invoices from '@/pages/app/project/dashboard/invoices/index.vue';
import GoogleTagManagerDashboard from '@/pages/app/project/dashboard/settings/integrations/google_tag_manager/index.vue';
import EditPaymentSchedule from '@/pages/app/project/dashboard/edit_payment_schedule/index.vue';
import { applyMeta } from './helpers';

export enum Page {
  app = 'app',
  project = 'project',
  projectSelect = 'projectSelect',
  dashboard = 'dashboard',
  dashboardHome = 'dashboardHome',
  dashboardOrders = 'dashboardOrders',
  dashboardOrder = 'dashboardOrder',
  dashboardLoans = 'dashboardLoans',
  dashboardLoan = 'dashboardLoan',
  dashboardPaymentPlans = 'dashboardPaymentPlans',
  dashboardPaymentPlan = 'dashboardPaymentPlan',
  dashboardStudents = 'dashboardStudents',
  dashboardStudent = 'dashboardStudent',
  dashboardSettlements = 'dashboardSettlements',
  dashboardApplications = 'dashboardApplications',
  dashboardSettings = 'dashboardSettings',
  dashboardProfile = 'dashboardProfile',
  // <-- Integrations
  dashboardIntegrations = 'dashboardIntegrations',
  zapierDashboard = 'zapierDashboard',
  googleTagManagerDashboard = 'googleTagManagerDashboard',
  nmiForm = 'nmiForm',
  stripeForm = 'stripeForm',
  avalaraForm = 'avalaraForm',
  // Integrations -->
  dashboardSettingsLogo = 'dashboardSettingsLogo',
  dashboardNotificationsSubscribers = 'dashboardNotificationsSubscribers',
  onboarding = 'onboarding',
  welcomeVideo = 'welcomeVideo',
  onboardingProgress = 'onboardingProgress',
  onboardingSubmitted = 'onboardingSubmitted',
  onboardingApproved = 'onboardingApproved',
  onboardingDeclined = 'onboardingDeclined',
  businessDetails = 'businessDetails',
  businessDetailsReview = 'businessDetailsReview',
  businessDetailsProduct = 'businessDetailsProduct',
  businessDetailsName = 'businessDetailsName',
  businessDetailsAddress = 'businessDetailsAddress',
  uploadLogo = 'uploadLogo',
  paymentDetails = 'paymentDetails',
  paymentDetailsReview = 'paymentDetailsReview',
  paymentDetailsForm = 'paymentDetailsForm',
  businessOwner = 'businessOwner',
  businessOwnerReview = 'businessOwnerReview',
  businessOwnerForm = 'businessOwnerForm',
  pricing = 'pricing',
  pricingInfo = 'pricingInfo',
  pricingTerms = 'pricingTerms',
  integrations = 'integrations',
  checkouts = 'checkouts',
  products = 'products',
  paymentSettings = 'paymentSettings',
  quickStartGuide = 'quickStartGuide',
  userManagement = 'userManagement',
  invoices = 'invoices',
  editPaymentSchedule = 'editPaymentSchedule',
}

const routes = [
  {
    path: '',
    name: Page.app,
    component: App,
    children: [
      {
        path: 'projects',
        name: Page.projectSelect,
        component: ProjectSelect,
      },
      {
        path: 'projects/:projectId',
        name: Page.project,
        component: Project,
        children: [
          {
            path: '',
            component: Dashboard,
            name: Page.dashboard,
            children: [
              {
                path: '',
                name: Page.dashboardHome,
                component: DashboardHome,
              },
              {
                path: 'checkouts',
                name: Page.checkouts,
                component: Checkouts,
              },
              {
                path: 'products',
                name: Page.products,
                component: Products,
              },
              {
                path: 'payment-settings',
                name: Page.paymentSettings,
                component: PaymentSettings,
              },
              {
                path: 'invoicing',
                name: Page.invoices,
                component: Invoices,
              },
              {
                path: 'orders',
                name: Page.dashboardOrders,
                component: DashboardOrders,
              },
              {
                path: 'orders/:id',
                name: Page.dashboardOrder,
                component: DashboardOrder,
              },
              {
                path: 'loans',
                name: Page.dashboardLoans,
                component: DashboardLoans,
              },
              {
                path: 'loans/:id',
                name: Page.dashboardLoan,
                component: DashboardLoan,
              },
              {
                path: 'edit-schedule/:id',
                name: Page.editPaymentSchedule,
                component: EditPaymentSchedule,
              },
              {
                path: 'payment-plans',
                name: Page.dashboardPaymentPlans,
                component: DashboardPaymentPlans,
                meta: { requirePpm: true },
              },
              {
                path: 'payment-plans/:id',
                name: Page.dashboardPaymentPlan,
                component: DashboardPaymentPlan,
                meta: { requirePpm: true },
              },
              {
                path: 'students',
                name: Page.dashboardStudents,
                component: DashboardStudents,
              },
              {
                path: 'students/:id',
                name: Page.dashboardStudent,
                component: DashboardStudent,
              },
              {
                path: 'settlements',
                name: Page.dashboardSettlements,
                component: DashboardSettlements,
              },
              {
                path: 'applications',
                name: Page.dashboardApplications,
                component: DashboardApplications,
              },
              {
                path: 'settings',
                name: Page.dashboardSettings,
                component: DashboardSettings,
                children: [
                  {
                    path: 'profile',
                    name: Page.dashboardProfile,
                    component: DashboardProfile,
                  },
                  {
                    path: 'integrations',
                    name: Page.dashboardIntegrations,
                    component: DashboardIntegrations,
                  },

                  {
                    path: 'logo',
                    name: Page.dashboardSettingsLogo,
                    component: DashboardSettingsLogo,
                  },
                  {
                    path: 'notifications-subscribers',
                    name: Page.dashboardNotificationsSubscribers,
                    component: DashboardsNotificationsSubscribers,
                  },
                  {
                    path: 'user-management',
                    name: Page.userManagement,
                    component: UserManagement,
                  },
                ],
              },
              {
                path: 'integrations/zapier',
                name: Page.zapierDashboard,
                component: ZapierDashboard,
              },
              {
                path: 'integrations/stripe',
                name: Page.stripeForm,
                component: StripeForm,
              },
              {
                path: 'integrations/nmi',
                name: Page.nmiForm,
                component: NmiForm,
              },
              {
                path: 'integrations/sales-tax/avalara',
                name: Page.avalaraForm,
                component: AvalaraForm,
              },
              {
                path: 'integrations/google-tag-manager',
                name: Page.googleTagManagerDashboard,
                component: GoogleTagManagerDashboard,
              },
              {
                path: 'quick-start-guide',
                name: Page.quickStartGuide,
                component: QuickStartGuide,
              },
            ],
          },
          {
            path: 'onboarding',
            component: Onboarding,
            name: Page.onboarding,
            children: [
              {
                path: 'progress',
                name: Page.onboardingProgress,
                component: OnboardingProgress,
              },
              {
                path: 'submitted',
                name: Page.onboardingSubmitted,
                component: OnboardingSubmitted,
              },
              {
                path: 'approved',
                name: Page.onboardingApproved,
                component: OnboardingApproved,
              },
              {
                path: 'declined',
                name: Page.onboardingDeclined,
                component: OnboardingDeclined,
              },
            ],
          },
          {
            path: 'business-details',
            name: Page.businessDetails,
            component: BusinessDetails,
            children: [
              {
                path: 'review',
                name: Page.businessDetailsReview,
                component: BusinessDetailsReview,
              },
              {
                path: 'select-product',
                name: Page.businessDetailsProduct,
                component: ProductSelection,
              },
              {
                path: 'name',
                name: Page.businessDetailsName,
                component: BusinessName,
              },
              {
                path: 'address',
                name: Page.businessDetailsAddress,
                component: BusinessAddress,
              },
            ],
          },
          {
            path: 'payment-details',
            name: Page.paymentDetails,
            component: PaymentDetails,
            children: [
              {
                path: '',
                name: Page.paymentDetailsForm,
                component: PaymentDetailsForm,
              },
              {
                path: 'review',
                name: Page.paymentDetailsReview,
                component: PaymentDetailsReview,
              },
            ],
          },
          {
            path: 'upload-logo',
            name: Page.uploadLogo,
            component: UploadLogo,
          },
          {
            path: 'business-owner',
            name: Page.businessOwner,
            component: BusinessOwner,
            children: [
              {
                path: '',
                name: Page.businessOwnerForm,
                component: BusinessOwnerForm,
              },
              {
                path: 'review',
                name: Page.businessOwnerReview,
                component: BusinessOwnerReview,
              },
            ],
          },
          {
            path: 'pricing',
            name: Page.pricing,
            component: Pricing,
            children: [
              {
                path: 'info',
                name: Page.pricingInfo,
                component: PricingInfo,
              },
              {
                path: 'terms',
                name: Page.pricingTerms,
                component: PricingTerms,
              },
            ],
          },
          {
            path: 'welcome',
            name: Page.welcomeVideo,
            component: WelcomeVideo,
          },
        ],
      },
    ],
  },
];

export const appRoutes = applyMeta(routes, { requireAuth: true });
